import {
  verifyOtp,
  generateOTP,
  updateUserToken,
  identifyCustomer,
} from 'actions/clz/0bod';
import Input from 'components/common/Input';
import OtpCountDown from 'components/common/OTPCountDown';
import { withFormik } from 'formik';
import { Checkbox } from 'homecredit-ui';
import Button from 'components/common/Button';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { isEmpty, get, noop } from 'lodash';
import { any, bool, func, objectOf } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Modal from 'components/common/Modal';
import Cycle from 'components/common/FullLoading/Cycle';
import FullLoading from 'components/common/FullLoading/FullLoading';
import { sendGAEvent } from 'utils/ga';
import {
  FORM_FIELDS,
  MAX_ATTEMPT,
  MAX_LENGTH_OTP,
  OTP_COUNT_SECOND,
} from './constant';

import s from './style.css';
import { informationValidation } from './validate';
import { MAX_RETRY } from '../constant';
import { MESSAGE } from 'constants/internal';

const FullLoadingCycle = FullLoading(Cycle);

class OTP extends Component {
  static propTypes = {
    values: objectOf(any),
    onUpdateUserToken: func,
    errors: objectOf(any),
    touched: bool,
    bodGenerateOTP: func,
    onClickBack: func,
    handleChange: func,
    newBOD: objectOf(any),
  };
  static defaultProps = {
    values: {},
    onUpdateUserToken: noop,
    errors: {},
    touched: true,
    bodGenerateOTP: noop,
    onClickBack: noop,
    handleChange: noop,
    newBOD: {},
  };
  constructor() {
    super();
    this.state = {
      retry: 0,
      attemp: 0,
      acceptedTerm: false,
      loading: false,
      isOpenRetryOTPLimited: false,
      isOpenVerifyOTP: false,
      isOpenVerifyLimited: false,
      isOpenSystemError: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (state.loading && props.newBOD.user.result) {
      return {
        ...state,
        loading: false,
      };
    }

    return state;
  }

  componentDidMount() {
    sendGAEvent(
      'Visit_Page',
      'OTP_Verification_Page',
      'ACL_0BOD_OTP_Verification',
    );
  }

  onSubmit = async e => {
    e.preventDefault();
    const { attemp } = this.state;
    const {
      validateForm,
      newBOD,
      onIdentifyCustomer,
      onUpdateUserToken,
    } = this.props;
    const errors = await validateForm();
    if (isEmpty(errors)) {
      this.setState({ loading: true });
      const { verificationID, user } = newBOD;
      const { values } = this.props;
      const payload = {
        verificationID,
        phoneNumber: user.primaryPhone,
        codeID: values[FORM_FIELDS.OTP],
        identificationNumber: user.idNumber,
      };
      const google = get(window, 'App.google');
      const siteKey = get(google, 'recaptcha.siteKey');
      /* eslint-disable no-undef */
      grecaptcha.ready(async () => {
        try {
          const token = await grecaptcha.execute(siteKey, { action: 'submit' });
          const response = await verifyOtp(payload, token);

          if (!response) throw new Error(MESSAGE.INTERNAL_ERROR);
          if (!isEmpty(response?.errors)) {
            const newAttemp = attemp + 1;
            this.setState({ attemp: newAttemp });
            newAttemp <= MAX_ATTEMP ? this.onToggleVerifyOTP() : this.onToggleVerifyLimited();
            this.setState({ loading: false });
          } else if (response?.token) {
            onUpdateUserToken(response?.token);
            await onIdentifyCustomer();
          }

          sendGAEvent(
            'Tap_Confirm_OTP_Button',
            'Confirm_OTP_Button',
            'ACL_0BOD_OTP_Verification',
          );
        } catch (error) {
          this.onToggleSystemError();
          this.setState({ loading: false });
        }
      });
    }
  };

  onToggleRetryOTPLimited = () =>
    this.setState({ isOpenRetryOTPLimited: !this.state.isOpenRetryOTPLimited });

  onToggleVerifyOTP = () =>
    this.setState({ isOpenVerifyOTP: !this.state.isOpenVerifyOTP });

  onToggleVerifyLimited = () =>
    this.setState({ isOpenVerifyLimited: !this.isOpenVerifyLimited });

  onToggleSystemError = () =>
    this.setState({ isOpenSystemError: !this.isOpenSystemError });

  onGoToBack = () => {
    this.onToggleVerifyLimited();
    this.props.onClickBack();
    sendGAEvent('Tap_Back', 'Back_Button', 'ACL_0BOD_OTP_Verification');
  };

  onFocus = () =>
    sendGAEvent(
      'Tap_Input_OTP_Textbox',
      'OTP_Textbox',
      'ACL_0BOD_OTP_Verification',
    );

  resendOTP = async () => {
    const { bodGenerateOTP, newBOD } = this.props;
    const { retry } = this.state;

    if (retry === MAX_RETRY) {
      this.onToggleRetryOTPLimited();
      return;
    }

    sendGAEvent(
      'Tap_Resend_OTP_Button',
      'Resend_OTP_Button',
      'ACL_0BOD_OTP_Verification',
    );
    const google = get(window, 'App.google');
    const siteKey = get(google, 'recaptcha.siteKey');
    const phoneNumber = newBOD?.user?.primaryPhone || '';
    /* eslint-disable no-undef */
    grecaptcha.ready(async () => {
      const token = await grecaptcha.execute(siteKey, { action: 'submit' });
      await bodGenerateOTP(phoneNumber, token);
      this.setState({ retry: this.state.retry + 1 });
    });
  };

  changeAcceptTerm = value => {
    this.setState({ acceptedTerm: value });
    sendGAEvent(
      'Tap_Agree_TnC_Checkbox',
      'Agree_TnC_Checkbox',
      'ACL_0BOD_OTP_Verification',
    );
  };

  render() {
    const { values, handleChange, errors, touched, newBOD } = this.props;
    const {
      acceptedTerm,
      loading,
      isOpenRetryOTPLimited,
      isOpenVerifyOTP,
      isOpenVerifyLimited,
      isOpenSystemError,
    } = this.state;
    const isReadySubmit = acceptedTerm && values[FORM_FIELDS.OTP];
    return (
      <div className={s.container}>
        <div className={s.wrapper}>
          <form className={s.form} onSubmit={this.onSubmit}>
            <div>
              <p className={s.title}>Xác thực số điện thoại</p>
              <p className={s.description}>
                Mã xác thực được gửi đến số điện thoại <br />
                {get(newBOD, 'user.phoneNumber', '')}
              </p>
              <div className={s.wrapperInput}>
                <Input
                  label="Nhập mã xác thực"
                  onChange={handleChange}
                  require
                  className={s.otpInput}
                  touched={touched}
                  name={FORM_FIELDS.OTP}
                  value={values[FORM_FIELDS.OTP]}
                  maxLength={MAX_LENGTH_OTP}
                  errorMsg={errors[FORM_FIELDS.OTP]}
                  touch={this.onFocus}
                />
              </div>
              <OtpCountDown
                text="Mã sẽ có hiệu lực trong"
                seconds={OTP_COUNT_SECOND}
                setOTPTimeOut={this.handleTimeoutOTP}
                resendOTP={this.resendOTP}
                retry={MAX_RETRY}
                newBod
              />
            </div>
            <div>
              <div className={s.rules}>
                <div className={s.checkboxWrapper}>
                  <Checkbox
                    checked={acceptedTerm}
                    onChange={this.changeAcceptTerm}
                  />
                </div>
                <div className={s.rulesWrapper}>
                  <p className={s.termTitle}>Tôi đồng ý</p>
                  <p>
                    Khi nhập mã xác thực này, tôi đồng ý cho phép Home Credit
                    thu thập, sử dụng và chia sẻ với bên thứ ba; cũng như đồng ý
                    cho các bên thứ ba này thu thập và sử dụng; các thông tin
                    liên quan đến tôi và/ hoặc các khoản vay của tôi cho mục
                    đích thẩm định tín dụng, định danh khách hàng và nhận thông
                    tin quảng cáo từ Home Credit.
                  </p>
                </div>
              </div>
              <Button
                type="submit"
                disabled={!isReadySubmit}
                loading={loading}
                onClick={this.handleClick}
                className={s.btnStart}
              >
                {loading ? 'ĐANG KIỂM TRA ...' : 'XÁC NHẬN'}
              </Button>
            </div>
          </form>
          <Modal
            className={s.modal}
            onClose={this.onToggleRetryOTPLimited}
            isOpen={isOpenRetryOTPLimited}
            footer={
              <div className={s.modalFooter}>
                <Button className={s.modalFooterBtn} onClick={this.onGoToBack}>
                  Đồng ý
                </Button>
                <Button
                  className={s.modalFooterBtnCancel}
                  onClick={this.onToggleRetryOTPLimited}
                >
                  Huỷ
                </Button>
              </div>
            }
          >
            <p className={s.titleModal}>Lưu ý</p>

            <p className={s.titleDes}>
              Quý khách không thể gửi lại Mã xác thực (OTP) cho số điện thoại
              &#32;này nữa.
            </p>
            <p className={s.titleDes}>
              Vui lòng chọn &ldquo;Đồng ý&ldquo; để thay đổi số điện thoại
              &#32;hoặc &ldquo;Hủy&ldquo; để sử dụng OTP hiện tại
            </p>
          </Modal>
          <Modal
            className={s.modal}
            onClose={this.onToggleVerifyOTP}
            isOpen={isOpenVerifyOTP}
            footer={
              <Button
                className={s.btnVerifyFailed}
                onClick={this.onToggleVerifyOTP}
              >
                Đồng ý
              </Button>
            }
          >
            <p className={s.titleModal}>Lưu ý</p>

            <p className={s.titleDes}>
              Mã xác thực(OTP) trên không đúng, xin vui lòng kiểm tra lại !
            </p>
          </Modal>
          <Modal
            className={s.modal}
            onClose={this.onToggleVerifyLimited}
            isOpen={isOpenVerifyLimited}
            footer={
              <Button className={s.btnVerifyFailed} onClick={this.onGoToBack}>
                Đồng ý
              </Button>
            }
          >
            <p className={s.titleModal}>Lưu ý</p>

            <p className={s.titleDes}>
              Bạn vừa nhập sai Mã Xác Thực quá {MAX_ATTEMPT} lần.
            </p>
            <p className={s.titleDes}>
              Vui lòng nhập lại số điện thoại liên lạc để xác thực.
            </p>
          </Modal>
          <Modal
            className={s.modal}
            onClose={this.onToggleSystemError}
            isOpen={isOpenSystemError}
            footer={
              <Button className={s.btnVerifyFailed} onClick={this.onGoToBack}>
                Tôi đã hiểu
              </Button>
            }
          >
            <p className={s.titleModal}>Thông báo</p>

            <p className={s.titleDes}>Hệ thống đang bảo trì</p>
          </Modal>
        </div>
        {loading && <FullLoadingCycle className={s.loading} />}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onUpdateUserToken: token => {
    dispatch(updateUserToken(token));
  },
  bodGenerateOTP: (phoneNumber, token) => {
    dispatch(generateOTP(phoneNumber, token));
  },
  onIdentifyCustomer: () => {
    dispatch(identifyCustomer());
  },
});
const mapStateToProps = ({ clz }) => ({
  newBOD: clz.newBOD,
});
const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withFormik({
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: informationValidation,
  }),
  withStyles(s),
);

export default enhance(OTP);
